import React, { createContext, useCallback, useState, useContext, ReactNode, useEffect } from 'react';

// import { parseCookies, setCookie, destroyCookie } from 'nookies'
import { useRouter } from 'next/router';
import { SistemaModel } from 'models/entityCore';
import { SistemaGPSIDModel } from './JWTContext';

export interface ItemAPP {
  codigo: number;
  label: string;
  icon?: string;
  color?: string;
  url: string | any;
  isToken?: boolean;
}

// export const listItemApp: ItemAPP[] = [
//   {
//     codigo: 1,
//     label: 'GPS R',
//     icon: '/images/gps_r.png',
//     color: '#0d2a38',
//     url: `${process.env.URL_GPSR}`,
//     isToken: true,
//   },
//   {
//     codigo: 2,
//     label: 'GPS A',
//     icon: '/images/gps_a.png',
//     color: '#00cdac',
//     url: process.env.URL_GPSR,
//     isToken: true,
//   },
//   {
//     codigo: 3,
//     label: 'GPS T',
//     icon: '/images/gps_t.png',
//     color: 'green.700',
//     url: process.env.URL_GPSR,
//     isToken: true,
//   },
//   {
//     codigo: 4,
//     label: 'GPS Amigo',
//     icon: '/images/gps_amigo.png',
//     color: 'red.400',
//     url: process.env.URL_GPSR,
//     isToken: true,
//   },
//   {
//     codigo: 5,
//     label: 'GPS I',
//     icon: '/images/gps_i.png',
//     color: 'red.700',
//     url: process.env.URL_GPSR,
//   },
//   {
//     codigo: 6,
//     label: 'GPS Hub',
//     icon: '/images/gps_hub2.png',
//     color: 'blue.800',
//     url: `${process.env.URL_GPSHUB}`,
//     isToken: true,
//   },
//   {
//     codigo: 7,
//     label: 'GPS Frota',
//     icon: '/images/gps_frota.png',
//     color: '#182D45',
//     url: `${process.env.URL_GPSFROTA}`,
//     isToken: true,
//   },
//   {
//     codigo: 8,
//     label: 'GPS Dmeal',
//     icon: '/images/gps_dmel.png',
//     color: '#182D45',
//     url: `${process.env.URL_GPSDMEL}`,
//     isToken: false,
//   },
// ];

interface AppContextData {
  update: (id: any) => Promise<void>;
  setAplicativos: (data: any) => void;
  convertData: (id: any) => void;

  data: ItemAPP[];
  aplicativos: ItemAPP[];
}

const AppContext = createContext<AppContextData>({} as AppContextData);

function AppProvider({ children, ...rest }) {
  const router = useRouter();

  const [aplicativos, setAplicativos] = useState<ItemAPP[]>([]);

  const [data, setData] = useState<ItemAPP[]>(() => {
    // Guarda de SSR: este inicializador roda durante o render, inclusive no
    // servidor, onde `window` nao existe.
    //
    // Hoje isso nao estoura por um acidente de arquitetura: o <PersistGate> do
    // redux-persist em _app.tsx renderiza `loading={null}` no servidor e nunca
    // reidrata lá, então toda a arvore abaixo dele (incluindo este provider) nao
    // e renderizada no SSR - o HTML do servidor volta com <div id="__next"> vazio.
    //
    // Ou seja: no dia em que o Redux/redux-persist for removido (ele e vestigial,
    // nao ha nenhum useSelector/useDispatch em codigo de feature), o PersistGate
    // sai, a arvore passa a renderizar no servidor e SEM esta guarda TODAS as
    // paginas passariam a responder 500 com "window is not defined".
    if (typeof window === 'undefined') return [];

    let sistemasAplicativosComAcessos: ItemAPP[] = [];
    const aux_aplicativos = window.localStorage.getItem('gpshub:aplicativos');
    if (aux_aplicativos) {
      const dataSistemaDTO: SistemaGPSIDModel[] = JSON.parse(aux_aplicativos);

      if (dataSistemaDTO.length > 0) {
        dataSistemaDTO.forEach((itemSistema) => {
          if (!itemSistema.nome.toLowerCase().includes('gpshub')) {
            const auxItemADD: ItemAPP = {
              codigo: itemSistema?.codigo,
              color: '#182D45',
              label: itemSistema?.nome,
              url: itemSistema?.link,
              isToken: itemSistema?.link?.includes('token') ? true : false,
            };
            sistemasAplicativosComAcessos.push(auxItemADD);
          }
        });
        setAplicativos(sistemasAplicativosComAcessos);
      } else setAplicativos([]);
    } else setAplicativos([]);
    //  FIM

    const portal_favorites = window.localStorage.getItem('portal_favorites');
    if (portal_favorites && sistemasAplicativosComAcessos.length > 0) {
      let listConverting: ItemAPP[] = [];
      const ids = JSON.parse(portal_favorites);

      ids.forEach((id) => {
        const findItem = sistemasAplicativosComAcessos?.find((itemAPP) => itemAPP.codigo === id);
        if (findItem) listConverting.push(findItem);
      });

      return listConverting;
    } else return [];
  });

  // useEffect(() => {
  //   let sistemasAplicativosComAcessos: ItemAPP[] = [];
  //   const aux_aplicativos = window.localStorage.getItem('gpshub:aplicativos');
  //   if (aux_aplicativos) {
  //     const dataSistemaDTO: SistemaGPSIDModel[] = JSON.parse(aux_aplicativos);

  //     if (dataSistemaDTO.length > 0) {
  //       dataSistemaDTO.forEach((itemSistema) => {
  //         if (!itemSistema.nome.toLowerCase().includes('gpshub')) {
  //           const auxItemADD: ItemAPP = {
  //             codigo: itemSistema?.codigo,
  //             color: '#182D45',
  //             label: itemSistema?.nome,
  //             url: itemSistema?.link,
  //             isToken: itemSistema?.link?.includes('token') ? true : false,
  //           };
  //           sistemasAplicativosComAcessos.push(auxItemADD);
  //         }
  //       });
  //       setAplicativos(sistemasAplicativosComAcessos);
  //     } else  setAplicativos([]);

  //   } else setAplicativos([]);
  // }, []);

  async function update(id) {
    let auxList: any[] = [...data];

    const itemAPP: any = aplicativos.find((item) => item.codigo === id);

    const itemDataExistsPosition = auxList.findIndex((item) => item.codigo == itemAPP.codigo);

    if (itemDataExistsPosition != -1) auxList.splice(itemDataExistsPosition, 1);
    else auxList.push(itemAPP);

    const ids = auxList.map((item) => {
      return item.codigo;
    });

    window.localStorage.setItem('portal_favorites', JSON.stringify(ids));
    setData(auxList);
  }

  function convertData(ids) {
    let listConverting: any[] = [];

    ids.forEach((id) => {
      const findItem = aplicativos.find((itemAPP) => itemAPP.codigo === id);
      listConverting.push(findItem);
    });

    setData(listConverting);
  }

  return (
    <AppContext.Provider value={{ update, data, convertData, aplicativos, setAplicativos }}>
      {children}
    </AppContext.Provider>
  );
}

function useApp() {
  const context = useContext(AppContext);

  return context;
}

export { AppProvider, useApp };
